import React, { Component } from 'react';
import Header from './Header.js';
import { Link } from 'react-router';
// import SubHeaderMain from './SubHeaderMain.js';
import Footer1 from './Footer1.js';
import WebFooter from './../../../Desktop/components/Common/WebFooter.js';

export default class NotFound extends Component {
	render(){
		var home_url='/';
		var footer=<Footer1 />;
		if(screen.width >= 800)
		{
			home_url='/web/home';
			footer=<WebFooter />
		}
		return(
			<div className="lgt_gry mob_deals">
				<Header />
				<section className="container error_cntnt">
					<div className="col-md-6 col-md-offset-3 eror_cntnt_blk">
						<h1>404 Error<br /><span>Oops! Page not found</span> </h1>
						<Link href={home_url} className="back_hm_btn">Back to Home</Link>
					</div>
				</section>
				{footer}
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Common/NotFound.js
 **/